module.exports = __webpack_public_path__ + "static/chaplin-6f9a90720fcc2cf2ea62170b344b63f6.png";